import React, { lazy, Suspense } from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
// import ScrollMemory from 'react-router-scroll-memory';

import Container from "./Container";

const Xterm = lazy(() => import("./Xterm"));

export default function () {
  return (
    <Router>
      {/*<ScrollMemory />*/}

      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route path="/dev/xterm">
            <Xterm />
          </Route>
          <Route component={Container} />
        </Switch>
      </Suspense>
    </Router>
  );
}
